import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { PopupLoginComponent } from 'src/app/components/modals/popup-login/popup-login.component';
import { PopupShoppingComponent } from 'src/app/components/modals/popup-shopping/popup-shopping.component';
import { IAnimal } from 'src/app/models/animal';
import { IAuctionBid, IOpenedSchedule } from 'src/app/models/transactions';
import { AuctionService } from 'src/app/services/auction.service';
import { StorageService } from 'src/app/services/storage.service';

@Component({
  selector: 'app-purchase-action',
  templateUrl: './purchase-action.component.html',
  styleUrls: ['./purchase-action.component.scss'],
})
export class PurchaseActionComponent implements OnInit {
  constructor(
    private storage: StorageService,
    private dialog: MatDialog,
    private auctionService: AuctionService
  ) {}

  @Input() auction_bid: IAuctionBid = {} as IAuctionBid;
  @Input() animal_obj: IAnimal = {} as IAnimal;
  @Input() opened_schedule: IOpenedSchedule = {} as IOpenedSchedule;

  @Input() increment: any = 0;
  @Output() eventSocket = new EventEmitter<any>();

  animal_bid: any = '';
  qtd_left = 1;

  ngOnInit() {
    console.log('---------SHOPPING---------');

    this.animal_bid = this.animal_obj.bid;
    this.qtd_left = Number(this.animal_obj.qtd);

    this.animal_obj.bids.forEach((bid) => {
      if (bid.status === 'ACEITO') {
        this.qtd_left -= bid.qtd;
      }
    });
  }

  openPopupBuyShopping() {
    if (!this.storage.token || this.storage.token === '') {
      this.openPopuplogIn();
      return;
    }

    const popupBuyRef = this.dialog.open(PopupShoppingComponent, {
      width: '90%',
      maxWidth: '500px',
      data: {
        id: this.auction_bid.id,
        auction: this.animal_obj,
      },
    });
    popupBuyRef.afterClosed().subscribe((result: any) => {
      if (result.action === 'yes') {
        this.auctionService
          .postAuctionBid(this.animal_obj.id, result.results)
          .subscribe(
            (data) => {
              this.eventSocket.emit(true);
            },
            (error) => {
              console.error(error);
            }
          );
      }
    });
  }

  openPopuplogIn() {
    const popupLoginRef = this.dialog.open(PopupLoginComponent, {
      width: '90%',
      maxWidth: '400px',
    });
    popupLoginRef.afterClosed().subscribe((result: any) => {
      if (result.action === 'yes') {
        this.eventSocket.emit(false);
      }
    });
  }
}
